import { Box, BoxProps, Text } from '@razorpay/blade/components';
import React, { ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  title: string | ReactNode;
  titleSuffix?: ReactNode;
  iconBackground: BoxProps['backgroundColor'];
  description: string | ReactNode;
  button?: ReactNode;
}

const ComponentHeader = ({
  icon,
  title,
  description,
  button,
  iconBackground,
  titleSuffix,
}: Props) => {
  return (
    <Box display={'flex'} flexDirection={'row'} gap={'spacing.4'}>
      <Box
        minWidth="36px"
        minHeight="36px"
        maxWidth="36px"
        maxHeight="36px"
        borderRadius={'round'}
        backgroundColor={iconBackground}
        display="flex"
        alignItems="center"
        justifyContent="center">
        {icon}
      </Box>
      <Box display={'flex'} flexDirection={'column'} gap={'spacing.2'}>
        <Box display={'flex'} flexDirection={'row'} gap={'spacing.3'}>
          <Text size="medium" weight="semibold">
            {title}
          </Text>
          {titleSuffix}
        </Box>
        <Text size="small" weight="regular" color="surface.text.gray.muted">
          {description}
        </Text>
      </Box>
      {button}
    </Box>
  );
};

export default ComponentHeader;
